import { render, staticRenderFns } from "./Detail-Sell.vue?vue&type=template&id=7b404301&scoped=true"
import script from "./Detail-Sell.vue?vue&type=script&lang=js"
export * from "./Detail-Sell.vue?vue&type=script&lang=js"
import style0 from "./Detail-Sell.vue?vue&type=style&index=0&id=7b404301&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b404301",
  null
  
)

export default component.exports